export default __webpack_public_path__ + "static/media/Catamaran-Bold.15ec554e.ttf";